import React from 'react';

export default function MetricsContainer(props) {
  const {
    metrics,
  } = props;

  const metricDifference = (value) => {
    if (value > 0) {
      return positiveDifference(value);
    } else if (value < 0) {
      return negativeDifference(value);
    } else {
      return equalDifference(value);
    }
  }

  const positiveDifference = (value) => {
    return (
      <div className="metric-difference positive">
        {value}%
        <i className="fas fa-caret-up"></i>
      </div>
    );
  }

  const negativeDifference = (value) => {
    return (
      <div className="metric-difference negative">
        {value}%
        <i className="fas fa-caret-down"></i>
      </div>
    );
  }

  const equalDifference = (value) => {
    return (
      <div className="metric-difference">
        {value}%
        <i className="fas fa-caret-left"></i>
      </div>
    );
  }

  function renderMetricCard(label, value, difference = null) {
    return (
      <div className="metric-card">
        {difference != null && (
          metricDifference(difference)
        )}
        <p className="metric-number">
        {value}
        </p>
        <div>
          {label}
        </div>
      </div>
    );
  }

  return (
    <div className="metrics-container">
      {renderMetricCard("Sales", `£${metrics.sales.value.toFixed(2)}`, metrics.sales.difference)}
      {renderMetricCard("New Customers", metrics.customers.value, metrics.customers.difference)}
      {renderMetricCard("Outstanding Surveys", metrics.surveys.value)}
      {renderMetricCard("Quotations Sent", metrics.quotes.value, metrics.quotes.difference)}
      {renderMetricCard("New Orders", metrics.orders.value, metrics.orders.difference)}
      {renderMetricCard("Outstanding Invoices", metrics.invoices.value)}
    </div>
  );
}
